// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableExtendFinance } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import Button from "@material-tailwind/react/Button";
import "react-toastify/dist/ReactToastify.css";
import { maxPageGlobal } from "../../../assets/config";
import { useNavigate, useParams } from "react-router-dom";
import * as XLSX from "xlsx-js-style";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { toast } from "react-toastify";
import { BsFileEarmarkExcelFill, BsFilePdfFill } from "react-icons/bs";

const PembayaranAPPage = ({}) => {
  const bisnisUnit = useMutation((formData) =>
    fetchGet("getMinMasterBisnisUnit")
  );

  const [search, setSearch] = useState("");
  const [searchText, setSearchText] = useState("");
  const [selectedBagian, setSelectedBagian] = useState("");
  const [selectedBU, setSelectedBU] = useState("");
  const [dataUpkeep, setdataUpkeep] = useState(null);
  const [count, setCount] = useState(maxPageGlobal);
  const [start, setStart] = useState(0);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [param, setParam] = useState({
    start: start,
    count: count,
    search: "",
    BisnisUnitID: "U0002",
    Menu: "PC",
  });

  const mutationData = useMutation((param) =>
    fetchGet("Accounting/PembayaranAP")
  );
  const KirimTrans = useMutation((formData) =>
    fetchPost("Accounting/PembayaranAP/approval", formData)
  );

  useEffect(() => {
    mutationData.mutate();
  }, [KirimTrans.status]);

  useEffect(() => {
    bisnisUnit.mutate();
    mutationData.mutate();
  }, []);

  const editOpener = (detail, BisnisUnitID) => {
    navigate("/finance/transaction/pembayaran-ap/" + detail);
  };

  const kirim = (detail) => {
    KirimTrans.mutate({ PembayaranAPID: detail, Status: "0" });
  };

  const header = [
    { name: "Pembayaran AP ID", key: "PembayaranAPID", modifiers: "Text" },
    { name: "No PO", key: "PurchaseOrderID", modifiers: "Text" },
    { name: "Bisnis Unit", key: "NamaBisnisUnit", modifiers: "Text" },
    { name: "Bagian", key: "NamaBagian", modifiers: "Text" },
    { name: "Detail Pembayaran", key: "DetailPembayaran", modifiers: "Text" },
    { name: "Dibayar Kepada", key: "DibayarKepada", modifiers: "Text" },
    { name: "Jenis Pembayaran", key: "JenisPembayaran", modifiers: "Text" },
    { name: "Tanggal", key: "Tanggal", modifiers: "Date" },
    { name: "Tanggal Cek", key: "TanggalCek", modifiers: "Date" },
    { name: "Status", key: "Status", modifiers: "Text" },
    { name: "Actions", key: "Edit", modifiers: "Button" },
  ];

  const navigate = useNavigate();

  // Search bar (client-side): cari di ID, No PO, Dibayar Kepada, Bagian, Jenis.
  const filterData = (event) => {
    setSearchText(event?.target?.value ?? "");
  };

  const ModalOpener = (detail) => {
    navigate("/finance/transaction/pembayaran-ap/");
  };

  function handleUpdatePage(newPage) {
    let newStart = newPage * count - count;

    setParam({
      start: newStart,
      count: count,
      search: "",
      BisnisUnitID: param.bisnisUnitID,
      Menu: "PC",
    });
  }

  function handleUpdateCount(newCount) {
    let calc = count - 1;
    if (calc === 0) {
      calc = 1;
    }
    setParam({
      start: parseInt(newCount === "-1" ? 0 : start),
      count: parseInt(newCount === "-1" ? count : newCount),
      search: search,
      Menu: "PC",
      BisnisUnitID: param.bisnisUnitID,
    });
    setPage(newCount === "-1" ? 0 : start);
    setStart(newCount === "-1" ? count : newCount);
    setSearch(search);
    setPage(1);
    setCount(newCount === "-1" ? count : newCount);
    setStart(newCount === "-1" ? 0 : start);
    setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
  }

  function handleModal(value) {}

  // ── Filter Bagian (dropdown) + search, keduanya client-side ──
  // fetchGet mengembalikan objek { status, message, data:[...] } — bukan array.
  const rawData = mutationData.data;
  const baseData = Array.isArray(rawData)
    ? rawData
    : Array.isArray(rawData?.data)
    ? rawData.data
    : [];
  // Opsi dropdown = daftar unik yang benar-benar muncul di data AP.
  const buOptions = Array.from(
    new Set(baseData.map((d) => d.NamaBisnisUnit).filter(Boolean))
  ).sort((a, b) => a.localeCompare(b));
  const bagianOptions = Array.from(
    new Set(
      baseData
        .filter((d) => !selectedBU || d.NamaBisnisUnit === selectedBU)
        .map((d) => d.NamaBagian)
        .filter(Boolean)
    )
  ).sort((a, b) => a.localeCompare(b));
  const displayData = baseData.filter((d) => {
    if (selectedBU && d.NamaBisnisUnit !== selectedBU) return false;
    if (selectedBagian && d.NamaBagian !== selectedBagian) return false;
    const kw = searchText.trim().toLowerCase();
    if (!kw) return true;
    return [
      d.PembayaranAPID,
      d.PurchaseOrderID,
      d.DibayarKepada,
      d.NamaBisnisUnit,
      d.NamaBagian,
      d.JenisPembayaran,
    ].some((v) => v && v.toString().toLowerCase().includes(kw));
  });

  // ── Export (mengikuti hasil filter + search yang tampil) ─────
  const exportHeader = [
    "Pembayaran AP ID",
    "No PO",
    "Bisnis Unit",
    "Bagian",
    "Detail Pembayaran",
    "Dibayar Kepada",
    "Jenis Pembayaran",
    "Tanggal",
    "Status",
  ];
  const exportBody = () =>
    displayData.map((d) => [
      d.PembayaranAPID || "",
      d.PurchaseOrderID || "",
      d.NamaBisnisUnit || "",
      d.NamaBagian || "",
      d.DetailPembayaran || "",
      d.DibayarKepada || "",
      d.JenisPembayaran || "",
      d.Tanggal || "",
      d.Status || "",
    ]);

  function handleExportExcel() {
    if (!displayData.length) {
      toast.warn("Tidak ada data untuk diexport");
      return;
    }
    const aoa = [exportHeader, ...exportBody()];
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    ws["!cols"] = exportHeader.map(() => ({ wch: 20 }));
    exportHeader.forEach((_, c) => {
      const a = XLSX.utils.encode_cell({ r: 0, c });
      if (ws[a])
        ws[a].s = {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2F5597" } },
          alignment: { horizontal: "center" },
        };
    });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Pembayaran AP");
    const ts = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
    XLSX.writeFile(wb, `Pembayaran_AP_${ts}.xlsx`);
    toast.success(`Berhasil export ${displayData.length} data`);
  }

  function handleExportPDF() {
    if (!displayData.length) {
      toast.warn("Tidak ada data untuk diexport");
      return;
    }
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(12);
    doc.text("Data Pembayaran AP", 14, 14);
    autoTable(doc, {
      head: [exportHeader],
      body: exportBody(),
      startY: 20,
      styles: { fontSize: 7, cellPadding: 2 },
      headStyles: { fillColor: [47, 85, 151], textColor: 255, fontStyle: "bold" },
    });
    doc.save("Pembayaran_AP.pdf");
  }

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col  content-center ">
                <div className="flex flex-row flex-wrap items-end gap-3 px-4 pt-4">
                  <div className="flex flex-col">
                    <label className="text-xs font-bold uppercase text-gray-600 mb-1">
                      Bisnis Unit
                    </label>
                    <select
                      value={selectedBU}
                      onChange={(e) => {
                        setSelectedBU(e.target.value);
                        setSelectedBagian("");
                      }}
                      className="border border-gray-300 rounded py-2 px-3 text-sm bg-white h-10 min-w-[200px] outline-none"
                    >
                      <option value="">Semua Bisnis Unit</option>
                      {buOptions.map((nama) => (
                        <option key={nama} value={nama}>
                          {nama}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="flex flex-col">
                    <label className="text-xs font-bold uppercase text-gray-600 mb-1">
                      Bagian
                    </label>
                    <select
                      value={selectedBagian}
                      onChange={(e) => setSelectedBagian(e.target.value)}
                      className="border border-gray-300 rounded py-2 px-3 text-sm bg-white h-10 min-w-[240px] outline-none"
                    >
                      <option value="">Semua Bagian</option>
                      {bagianOptions.map((nama) => (
                        <option key={nama} value={nama}>
                          {nama}
                        </option>
                      ))}
                    </select>
                  </div>
                  <button
                    onClick={handleExportExcel}
                    className="flex items-center gap-2 h-10 px-4 rounded shadow text-sm font-semibold border bg-white text-gray-800 border-green-600 hover:bg-green-600 hover:text-white"
                  >
                    <BsFileEarmarkExcelFill /> Export Excel
                  </button>
                  <button
                    onClick={handleExportPDF}
                    className="flex items-center gap-2 h-10 px-4 rounded shadow text-sm font-semibold border bg-white text-gray-800 border-red-400 hover:bg-red-400 hover:text-white"
                  >
                    <BsFilePdfFill /> Export PDF
                  </button>
                  <span className="text-xs text-gray-500 ml-auto self-center">
                    {displayData.length} data
                  </span>
                </div>
                <DynamicTableExtendFinance
                  types="penerimaan-barang"
                  data={{ data: displayData, count: displayData.length }}
                  header={header}
                  menuController={filterData}
                  Master={true}
                  currentPage={page}
                  maxPage={maxPage}
                  name={"UserPC"}
                  OnClick={ModalOpener}
                  updateCount={handleUpdateCount}
                  count={count}
                  updatePage={handleUpdatePage}
                  modal={handleModal}
                  editor={editOpener}
                  kirim={kirim}
                  // "Revisi" = Status 2 = DITOLAK (penamaan lama, sama dgn Kas Bank).
                  // Tanpa baris ini dokumen yang ditolak bisa diedit tapi tak punya
                  // tombol Kirim sama sekali — mentok permanen.
                  kirimStatus={["Menunggu Dikirim", "Revisi"]}
                  primarykey={"PembayaranAPID"}
                />
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PembayaranAPPage;
